import React, { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { useCookies } from 'react-cookie'

import server from 'server/serverController2'
import { UserInfoActions, UserPermissionActions } from 'store/actionCreators'
import { getQueryStringObject } from 'utils/utils'

import CenterModal from 'components/presenters/modal/CenterModal'
import TermsAndConditionCheckModal from 'components/containers/signup/TermsAndConditionCheckModal'

import TitleHeader from 'components/presenters/header/TitleHeader'
import EmailFormScene from 'components/containers/signup/EmailFormScene'
import PasswordFormScene from 'components/containers/signup/PasswordFormScene'
import PhoneSMSAuthScene from 'components/containers/signup/PhoneSMSAuthScene'
import GenderAndBirthScene from 'components/containers/signup/GenderAndBirthScene'
import UserCategoryScene from 'components/containers/signup/UserCategoryScene'
import UserDetailCategoryScene from 'components/containers/signup/UserDetailCategoryScene'
import NicknameFormScene from 'components/containers/signup/NicknameFormScene'
import ConfirmNotificationScene from 'components/containers/signup/ConfirmNotificationScene'
import { sendWebViewMsg } from 'utils/bridge'
import useCreateOnboardingTodoMutate from 'hooks/queries/task/useCreateOnboardingTodoMutate'

export default function SignupLayout() {
  const TOTAL_SCENE_NUM = 7
  const [cookies, setCookie, removeCookie] = useCookies()
  const history = useHistory()
  const [currSceneNum, setCurrSceneNum] = useState(1)

  const isOnboarding = useLocation().state?.isOnboarding ?? false

  const [email, setEmail] = useState(null)
  const [password, setPassword] = useState(null)
  const [phone, setPhone] = useState(null)
  const [phoneToken, setPhoneToken] = useState(null)
  const [sex, setSex] = useState(null)
  const [birth, setBirth] = useState(null)
  const [parentCategories, setParentCategories] = useState([])
  const [detailCategories, setDetailCategories] = useState([])
  const [nickname, setNickname] = useState(null)
  const [checkList, setCheckList] = useState([])
  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false)
  const [centerModalVisible, setCenterModalVisible] = useState(false)
  const [centerModalDataList, setCenterModalDataList] = useState({})
  const [onModalComplete, setOnModalComplete] = useState(null)
  const [onModalCancel, setOnModalCancel] = useState(null)
  //TermsAndConditionModal
  const [termsAndConditionCheckModalVisible, setTermsAndConditionCheckModalVisible] =
    useState(false)
  //
  const [isReqSignup, setIsReqSignup] = useState(false)
  // const [] = useState(false);

  const { mutateAsync: createOnboardingTodo } = useCreateOnboardingTodoMutate()

  const { redirect_path: redirectPath } = getQueryStringObject()

  //Init Center Modal State
  useEffect(() => {
    if (initCenterModal === true) {
      setCenterModalVisible(false)
      setCenterModalDataList({})
      setOnModalComplete(null)
      setOnModalCancel(null)
      setInitCenterModal(false)
    }
  }, [initCenterModal])

  const handleSignUpClick = (checkedList) => {
    setIsReqSignup(true)
    setCheckList(checkedList)
  }

  const handleSubmit = useCallback(
    async (checkedList) => {
      const body = {}
      body['email'] = email
      body['password'] = password
      body['phone'] = phone
      body['phone_token'] = phoneToken
      body['sex'] = sex
      body['birth'] = birth
      body['category_no_list'] = [...parentCategories, ...detailCategories].map((data) => data.no)
      body['nickname'] = nickname
      if (!checkedList.includes(3)) {
        body['push_notification'] = false
      } else {
        body['push_notification'] = true
      }

      await server.postRequestData(`auth/signup`, body, async (res) => {
        try {
          if (res.success !== 1) {
            return
          }

          const jsonData = res['data']
          const userData = jsonData['user']
          const permissionData = jsonData['permissions']
          UserInfoActions.updateUserState({
            name: userData.nickname,
            email: userData.email,
            id: userData.no,
            isLogin: true,
            achievement_goal: userData.achievement_goal,
            profile_img: userData.profile_img,
            exp_point: userData.exp_point,
          })
          UserInfoActions.updateRole({
            role: userData['role'],
          })
          if (permissionData) {
            UserPermissionActions.updateUserPermission({ matching: permissionData['matching'] })
          }

          if (cookies['onboarding_habit']
            && cookies['onboarding_description'] !== undefined
            && cookies['onboarding_original_image_name']
            && cookies['onboarding_original_image_path']
            && cookies['onboarding_merged_image_name']
            && cookies['onboarding_merged_image_path']
          ) {
            try {
              await createOnboardingTodo({
                onboardingType: cookies['onboarding_habit'],
                description: cookies['onboarding_description'],
                originalImageName: cookies['onboarding_original_image_name'],
                originalImagePath: cookies['onboarding_original_image_path'],
                mergedImageName: cookies['onboarding_merged_image_name'],
                mergedImagePath: cookies['onboarding_merged_image_path'],
              })
    
              removeCookie('onboarding_habit', { path: '/' })
              removeCookie('onboarding_description', { path: '/' })
              removeCookie('onboarding_original_image_name', { path: '/' })
              removeCookie('onboarding_original_image_path', { path: '/' })
              removeCookie('onboarding_merged_image_name', { path: '/' })
              removeCookie('onboarding_merged_image_path', { path: '/' })
              
            } catch (e) {
              setCenterModalVisible(true)
              setCenterModalDataList({
                description: '3일 챌린지 인증기록을 저장하지 못했어요.\n카카오로 문의 주시면 해결해 드릴게요.',
                confirmTxt: '문의하기',
              })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
                window.open('https://pf.kakao.com/_gmtJs/chat', '_blank')
              })
              setOnModalCancel(()=> () => {
                setInitCenterModal(true)
              })
              return
            }
          }

          setCookie('is_onboarding_completed', 'true', { path: '/', maxAge: 60 * 60 * 24 * 365 })
          sendWebViewMsg({ action: 'REQ_COOKIE_FLUSH' })

          if (!checkedList.includes(3)) {
            setCurrSceneNum(8)
            setTermsAndConditionCheckModalVisible(false)
          } else {
            if (redirectPath) {
              history.replace(redirectPath)
            } else {
              history.replace('/')
            }
          }
        } catch (err) {
          console.log(err)
        }
      })
    },
    [
      birth,
      detailCategories,
      email,
      history,
      nickname,
      parentCategories,
      password,
      phone,
      phoneToken,
      redirectPath,
      sex,
    ],
  )

  useEffect(() => {
    if (isReqSignup && checkList.length < 1) return
    setIsReqSignup(true)
    handleSubmit(checkList)
  }, [isReqSignup, checkList, handleSubmit])

  const currScene = () => {
    if (currSceneNum === 1) {
      return (
        <EmailFormScene
          initEmail={email}
          currSceneNum={currSceneNum}
          totalSceneNum={TOTAL_SCENE_NUM}
          onComplete={(email) => {
            setEmail(email)
            setCurrSceneNum(2)
          }}
          onError={(error) => {
            // if(error['error_detail'] ==="FRIEND_STATUS_REQUIRED")
            // {
            //     setCenterModalVisible(true);
            //     setCenterModalDataList({description:"친구가 되면 게시물을 볼 수 있어요!"});
            //     setOnModalComplete(()=>()=>{
            //         setInitCenterModal(true);
            //     })
            // }
            // else if(error['error_detail']==='SUBMITION_TIME_NOT_STARTED')
            // {
            //     setCenterModalVisible(true);
            //     setCenterModalDataList({description:"아직 인증시간이 시작되지 않았습니다."});
            //     setOnModalComplete(()=>()=>{
            //         setInitCenterModal(true);
            //     })
            // }
          }}
        />
      )
    } else if (currSceneNum === 2) {
      return (
        <PasswordFormScene
          initPassword={password}
          currSceneNum={currSceneNum}
          totalSceneNum={TOTAL_SCENE_NUM}
          onComplete={(password) => {
            setPassword(password)
            setCurrSceneNum(3)
          }}
          onError={(error) => {}}
        />
      )
    } else if (currSceneNum === 3) {
      return (
        <PhoneSMSAuthScene
          initPhone={phone}
          currSceneNum={currSceneNum}
          totalSceneNum={TOTAL_SCENE_NUM}
          onComplete={(data) => {
            setCurrSceneNum(4)
            setPhone(data['phone'])
            setPhoneToken(data['token'])
          }}
          onError={(error) => {
            if (error['detail_code'] === 'SMS_DATA_NOT_EXIST') {
              setCenterModalVisible(true)
              setCenterModalDataList({ description: '인증번호가 맞지 않아요.' })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            } else if (error['detail_code'] === 'TIME_EXCEEDED') {
              setCenterModalVisible(true)
              setCenterModalDataList({ description: '시간이 초과되었어요.\n 다시 시도해 주세요.' })
              setOnModalComplete(() => () => {
                setInitCenterModal(true)
              })
            }
          }}
        />
      )
    } else if (currSceneNum === 4) {
      return (
        <GenderAndBirthScene
          initSex={sex}
          initBirth={birth}
          currSceneNum={currSceneNum}
          totalSceneNum={TOTAL_SCENE_NUM}
          onComplete={(data) => {
            setSex(data.sex)
            setBirth(data.birth)
            setCurrSceneNum(5)
          }}
          onError={(error) => {}}
        />
      )
    } else if (currSceneNum === 5) {
      return (
        <UserCategoryScene
          initCategories={parentCategories}
          currSceneNum={currSceneNum}
          totalSceneNum={TOTAL_SCENE_NUM}
          onComplete={(data) => {
            setParentCategories(data['categories'])
            setCurrSceneNum(6)
          }}
          onError={(error) => {}}
        />
      )
    } else if (currSceneNum === 6) {
      return (
        <UserDetailCategoryScene
          initCategories={detailCategories}
          parentCategories={parentCategories}
          currSceneNum={currSceneNum}
          totalSceneNum={TOTAL_SCENE_NUM}
          onComplete={(data) => {
            setDetailCategories(data['categories'])
            setCurrSceneNum(7)
          }}
          onError={(error) => {}}
        />
      )
    } else if (currSceneNum === 7) {
      return (
        <NicknameFormScene
          currSceneNum={currSceneNum}
          totalSceneNum={TOTAL_SCENE_NUM}
          onComplete={(nickname) => {
            setNickname(nickname)
            setTermsAndConditionCheckModalVisible(true)
          }}
          onError={(error) => {}}
        />
      )
    } else if (currSceneNum === 8) {
      return (
        <ConfirmNotificationScene currSceneNum={currSceneNum} totalSceneNum={TOTAL_SCENE_NUM} />
      )
    }
  }

  return (
    <SignupWrapper>
      {currSceneNum !== 8
        ? <HeaderWrapper>
            <TitleHeader
              hideBtn={currSceneNum === 8}
              title={currSceneNum !== 8 ? '회원가입' : ''}
              onBackBtn={() => {
                if (currSceneNum <= 1) {
                  history.goBack()
                } else {
                  setCurrSceneNum(currSceneNum - 1)
                }
              }}
            />
          </HeaderWrapper>
        : null}
      <BodyWrapper>{currScene()}</BodyWrapper>
      {termsAndConditionCheckModalVisible ? (
        <TermsAndConditionCheckModal
          setTermsAndConditionCheckModalVisible={setTermsAndConditionCheckModalVisible}
          onComplete={handleSignUpClick}
        />
      ) : null}
      <CenterModal
        modalVisible={centerModalVisible}
        setModalVisible={setCenterModalVisible}
        dataList={centerModalDataList}
        onCancel={onModalCancel}
        onComplete={onModalComplete}
      />
    </SignupWrapper>
  )
}

const SignupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
`

const HeaderWrapper = styled.div`
  flex-shrink: 0;
  height: calc(100vw * (51 / 375));
  max-height: calc(100vw * (51 / 375));
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  height: calc(100vh - calc(100vw * (51 / 375)));
`
